import { defaultTheme } from '@amzn/storm-ui';

const { blue, red, gray, lightBlue, green, orange } = defaultTheme.color;

export const CustomIconButtonColor = {
  search: lightBlue[500],
  pencil: blue[700],
  delete: red[700],
  download: gray[700],
  plus: blue[500],
  minus: red[700],
  refresh: blue[500],
  restore: green[600],
  cancel: orange[600],
};
